import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [MatIcon, TranslatePipe, FlexLayoutModule],
  selector: 'iot-platform-ui-timeline-list',
  templateUrl: './timeline-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./timeline-list.component.scss']
})
export class TimelineListComponent {
  title = input<string>();
  icon = input<string>();
}
